import { Controller } from "@hotwired/stimulus"

// Head Office and General petty cash advances are overhead and carry no cost
// centre — the database rejects one outright. Hide the picker rather than let
// someone fill it in and be told no on submit.
export default class extends Controller {
  static targets = ["scope", "costCenter", "costCenterSelect"]

  connect() {
    this.toggle()
  }

  toggle() {
    const needsCostCenter = ["project", "workshop"].includes(this.scopeTarget.value)

    this.costCenterTarget.style.display = needsCostCenter ? "" : "none"
    this.costCenterSelectTarget.required = needsCostCenter
    // Clear it on the way out, so a stale selection cannot be submitted with a
    // scope that forbids one.
    if (!needsCostCenter) this.costCenterSelectTarget.value = ""
  }
}
